import { ITopicSection } from "@/api/topics";
import { Stack, Typography } from "@mui/material";
import { ChecklistSectionAccordion } from "./ChecklistSectionAccordion";

interface ChecklistTopicSectionsProps {
    sections: ITopicSection[];
}

/**
 * Iterates through topic sections and renders section accordions.
 * Filters out empty sections (no clauses).
 */
export const ChecklistTopicSections = ({
    sections,
}: ChecklistTopicSectionsProps) => {
    // Filter to sections that have content
    const sectionsWithContent = sections.filter(
        (section) => section.clauses.length > 0
    );

    if (sectionsWithContent.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                No clauses in this topic.
            </Typography>
        );
    }

    return (
        <Stack spacing={1}>
            {sectionsWithContent.map((section, index) => {
                // Use document section type id or index-based key for null sections
                const key =
                    section.document_section_type?.id ?? `general-${index}`;
                return (
                    <ChecklistSectionAccordion key={key} section={section} />
                );
            })}
        </Stack>
    );
};
